import script from "./SpeV2EmailMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeV2EmailMapping.vue?vue&type=script&setup=true&lang=js"

import "./SpeV2EmailMapping.vue?vue&type=style&index=0&id=4b57d7f4&scoped=true&lang=css"
import "./SpeV2EmailMapping.vue?vue&type=style&index=1&id=4b57d7f4&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b57d7f4"]])

export default __exports__